/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { roundDependencies } from './dependenciesRound.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCeil } from '../../factoriesAny.js';
export var ceilDependencies = {
  roundDependencies: roundDependencies,
  typedDependencies: typedDependencies,
  createCeil: createCeil
};